precision highp float;

#define NUM_OCTAVES 6

uniform float uTime;
uniform float uFade;
uniform vec3 uColor;
uniform float uNoiseFrequency;
uniform float uNoiseAmplitude;
uniform float uNoiseSpeed;
uniform vec2 uSmokeVelocity;

varying vec2 vUv;

#pragma glslify: noise = require(glsl-noise/simplex/3d)

float fbm(vec3 x) {
	float v = 0.0;
	float a = 0.5;
	vec3 shift = vec3(100);

	for (int i = 0; i < NUM_OCTAVES; ++i) {
		v += a * noise(x);
		x = x * 2.0 + shift;
		a *= 0.5;
	}
	return v;
}

void main() {
    vec3 noiseSeed = vec3(vUv, uNoiseSpeed + uTime * uNoiseSpeed);
    float noise = fbm(noiseSeed);

    vec3 color1 = vec3(uColor);
    vec3 color2 = vec3(uColor) * 0.01;

    vec3 final = mix(color1, color2, noise);

    // Render to buffer
    gl_FragColor = vec4(final, uFade);
}
